<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-title style="padding: 10px 0 0 10px; height: 30px;">
                        <v-col cols="12">
                            <span style="position: relative; top: -15px;">{{ $t('print.title') }}</span>
                            <v-btn icon style="top: -20px; left: 10px; float: right;">
                                <v-icon @click="showDialog=false">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-card-title>
                    <v-card-text style="padding: 5px;">
                        <v-container>
                            <v-row v-if="isTimestampsHigherThan24h(timestamp)" style="margin-top: 0; margin-bottom: 10px;">
                                <v-col cols="12" style="padding-bottom: 0;">                                    
																	<v-alert type="error" dense class="my-0">
																		{{ $t('print.ticket-too-long-warning') }}
																	</v-alert>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top: 0; margin-bottom: 0;">
                                <v-col col="12" style="padding-bottom: 0;">
                                    <v-select outlined
                                      class="search-1"
                                      v-model="refreshRate"
                                      :items="refreshRates"
																			:label="$t('print.select-refresh-rate')">
                                    </v-select>
                                </v-col>
                            </v-row>
														<v-row style="margin-top: 5px; margin-bottom: 0;">
                                <v-col cols="7" style="padding-bottom: 0;">
                                    <v-select outlined
                                      class="search-1"
                                      v-model="printerName"
                                      :items="printers"
																			:disabled="printers.length <= 1"
																			:label="$t('print.select-printer')">
                                    </v-select>
                                </v-col>
                                <v-col cols="5" style="padding: 22px 12px 0 0;">
                                    <v-btn :disabled="!printerName" class="wemob-btn primary px-2" style="float: right;" @click="connectPrinter()">
																			{{ $t('print.connect-printer') }}
																		</v-btn>
                                </v-col>
                                <v-col v-if="printerStatusMessage" cols="12" style="padding-bottom: 0;">                                    
																	<v-alert :type="printerStatus" dense class="my-0">
																		{{ printerStatusMessage }}
																	</v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="showDialog=false">{{ $t('dialog.cancel') }}</v-btn>
                        <v-btn class="wemob-btn primary" :disabled="!isPrinterConnected" style="width: 100px;" @click="doOk()">{{ $t('dialog.ok') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <WaitDialog ref='dlgWait'/>
    </v-row>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'
import api from "../../../api/wedrive";
import PrintUtil from "./PrintUtil";
import cordova from "../../../api/cordova";
import WaitDialog from './WaitDialog';
import ReportUtil from "./ReportUtil";

export default {
    name: 'PrintDialog',
    mixins: [ BaseModule, ReportUtil, PrintUtil ],
    components: {
      WaitDialog
    },
    data() {
        return {
            idFleet: null,
            idMobile : null, 
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,            
            timestamp: {},
            sensorIds: [],
						refreshRates: [ 
							{ text: '1 ' + this.$t('print.minutes'), value: 1 },
							{ text: '5 ' + this.$t('print.minutes'), value: 5 },
							{ text: '10 ' + this.$t('print.minutes'), value: 10 },
							{ text: '15 ' + this.$t('print.minutes'), value: 15 },
							{ text: '30 ' + this.$t('print.minutes'), value: 30 },
							{ text: '60 ' + this.$t('print.minutes'), value: 60 }
						],
						refreshRate: 10,
						printers: [],
						printerName: null,
						isPrinterConnected: false,
						printerStatus: 'error',
						printerStatusMessage: null,
            showDialog: false,
            errorType: -1,
            msgCb: null,
        }
    },
    mounted() {
        window.$vue.$on('printer-list', this.updatePrinterList);
        window.$vue.$on('printer-connection-result', this.updatePrinterStatus);
        window.$vue.$on('print-result', this.updatePrintResult);
    },
    methods: {
        isVisible: function() {
            return this.showDialog;
        },
        close: function() {
            this.showDialog = false; 
        },
        open: function(idFleet, idMobile, sensorIds, timestamp, msgCb) {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
						
						this.printerStatus = 'error';
						this.printerStatusMessage = this.$t('print.no-printers-found');

						this.getPrinterList();
            
            this.showDialog = true;
            this.idFleet = idFleet;
            this.idMobile = idMobile;
						this.sensorIds = sensorIds;
            this.timestamp = timestamp;
						this.refreshRate = 10;
            this.msgCb = msgCb;
        },
				getPrinterList() {
						cordova.getPrinterList();
				},
				connectPrinter() {
						cordova.connectPrinter({ name: this.printerName });
				},
				updatePrinterList(printerList) {
						if (printerList.length == 0) {
							this.printers = [];
							this.printerName = null;
							this.isPrinterConnected = false;
							this.printerStatus = 'error';
							this.printerStatusMessage = this.$t('print.no-printers-found');
							return;
						}
						
						this.printerStatus = 'error';
						this.printerStatusMessage = this.$t('print.printer-disconnected');
						this.isPrinterConnected = false;

						// Si es Android, pasamos el nombre del dispositivo
						// Si es iOS, pasamos la posición del dispositivo en el array
						for (var i = 0; i < printerList.length; i++) {
							if (this.$store.state.wedrive.devicePlatform == 'android') {
								this.printers = printerList.map(x => x.name);
							} else {
								this.printers = i.toString();
							}
						}
						this.printerName = this.printers[0];
				},
        updatePrinterStatus(result) {
						if (result.rsok) {
							this.printerStatus = 'success';
							this.printerStatusMessage = this.$t('print.printer-connected');
							this.isPrinterConnected = true;
						} else {
							this.printerStatus = 'error';
							this.printerStatusMessage = this.$t('print.printer-disconnected');
							this.isPrinterConnected = false;
						}
				},
				updatePrintResult(result) {
						this.$refs.dlgWait.close();

						if (result.rsok) {					
							this.showDialog = false;
							if (this.msgCb) {
									this.msgCb({ text: this.$t('print.data-sent-successfully'), color: 'success', timeout: 6000 });
							}
						} else {
							this.printerStatus = 'error';
							this.printerStatusMessage = this.$t('print.print-error');
						}
				},
        doOk: function() {
            if (!this.$refs.form.validate()) {
                return;
            }

            api.historicTempByPeriod(this.idFleet, this.idMobile, this.timestamp.init, this.timestamp.end, this.refreshRate,        
            (data) => {
								this.$refs.dlgWait.open('print');

                var jsonEntities = this.buildTicket(this.timestamp, this.sensorIds, this.refreshRate, data);

								cordova.printTicket(jsonEntities);
            },
            (error) => {
                if (this.msgCb) {
										this.msgCb({ text: error, color: 'error', timeout: 3000 });
								}
            });
        },
    },
  }
</script>